import React, { useState } from 'react';

const LoginGate = ({ onLogin }) => {
  const [loading, setLoading] = useState(false);
  const [loadingPlatform, setLoadingPlatform] = useState('');

  const handleSocialLogin = async (platform) => {
    setLoading(true);
    setLoadingPlatform(platform);
    
    // Simulate API call
    setTimeout(() => {
      const userData = {
        name: `User from ${platform.charAt(0).toUpperCase() + platform.slice(1)}`,
        avatar: getPlatformAvatar(platform),
        platform: platform
      };
      
      onLogin(userData);
      setLoading(false);
      setLoadingPlatform('');
    }, 2000);
  };

  const getPlatformAvatar = (platform) => {
    const avatars = {
      facebook: 'https://via.placeholder.com/32/1877F2/FFFFFF?text=F',
      google: 'https://via.placeholder.com/32/4285F4/FFFFFF?text=G',
      instagram: 'https://via.placeholder.com/32/E4405F/FFFFFF?text=I'
    };
    return avatars[platform] || 'https://via.placeholder.com/32/F44336/FFFFFF?text=U';
  };

  return (
    <div className="login-gate">
      <div className="login-container animate-fadeInUp">
        <div className="login-header">
          <h1 className="login-title gradient-text">La Soirée du Rire</h1>
          <p className="login-subtitle">Analytics Dashboard</p>
        </div>
        <div className="login-content">
          <h2 className="text-highlight">Welcome Back!</h2>
          <p>Sign in to access your analytics dashboard and track your social media performance across all platforms with AI-powered insights.</p>
          <div className="social-login-buttons">
            <button 
              className="social-btn facebook-btn hover-lift" 
              onClick={() => handleSocialLogin('facebook')}
              disabled={loading}
            >
              {loading && loadingPlatform === 'facebook' ? (
                <div className="loading"></div>
              ) : (
                <i className="fab fa-facebook-f"></i>
              )}
              {loading && loadingPlatform === 'facebook' ? 'Logging in...' : 'Continue with Facebook'}
            </button>
            <button 
              className="social-btn google-btn hover-lift" 
              onClick={() => handleSocialLogin('google')}
              disabled={loading}
            >
              {loading && loadingPlatform === 'google' ? (
                <div className="loading"></div>
              ) : (
                <i className="fab fa-google"></i>
              )}
              {loading && loadingPlatform === 'google' ? 'Logging in...' : 'Continue with Google'}
            </button>
            <button 
              className="social-btn instagram-btn hover-lift" 
              onClick={() => handleSocialLogin('instagram')}
              disabled={loading}
            >
              {loading && loadingPlatform === 'instagram' ? (
                <div className="loading"></div>
              ) : (
                <i className="fab fa-instagram"></i>
              )}
              {loading && loadingPlatform === 'instagram' ? 'Logging in...' : 'Continue with Instagram'}
            </button>
          </div>
          <div className="login-features">
            <div className="feature-item hover-scale">
              <i className="fas fa-chart-line"></i>
              <span>Real-time Analytics</span>
            </div>
            <div className="feature-item hover-scale">
              <i className="fas fa-share-alt"></i>
              <span>Multi-Platform Tracking</span>
            </div>
            <div className="feature-item hover-scale">
              <i className="fas fa-mobile-alt"></i>
              <span>Mobile Responsive</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginGate;
